import { render } from "./delegated-channel-inviting.vue?vue&type=template&id=0069d03e&lang=pug"
import script from "./delegated-channel-inviting.vue?vue&type=script&lang=js"
export * from "./delegated-channel-inviting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__